(function () {
  function debounce(fn, wait) {
    wait = wait || 300;
    var t;
    return function () {
      var self = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(self, args);
      }, wait);
    };
  }

  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.slider ? this.querySelectorAll('.slider__slide') : [];
      this.sliderFirstItemNode = this.slider ? this.slider.querySelector('.slider__slide') : null;
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      this.dots = this.querySelectorAll('.dot') ? Array.from(this.querySelectorAll('.dot')) : [];
      this.progress = this.querySelector('.slider-progress') || false;

      if (!this.slider || !this.nextButton) return;

      this.initPages();
      var resizeObserver = new ResizeObserver(
        (function (self) {
          return function () {
            self.initPages();
          };
        })(this)
      );
      resizeObserver.observe(this.slider);

      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

      if (this.dots.length) {
        this.dots.forEach(function (item) {
          item.addEventListener('click', this.onDotClick.bind(this));
        }.bind(this));
      }

      this._scrollToDebounced = debounce(this.scrollTo.bind(this), 300);
    }

    initPages(event) {
      this.sliderItems = this.querySelectorAll('.slider__slide');
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(function (el) {
        return el.clientWidth > 0;
      });

      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      if (this.totalPages < 1) this.totalPages = 1;

      this.update();
    }

    update() {
      if (!this.slider || !this.nextButton) return;
      if (this.sliderItemsToShow.length < 2) return;

      var previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
      if (this.currentPage < 1) this.currentPage = 1;
      if (this.currentPage > this.totalPages) this.currentPage = this.totalPages;

      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }

      this.updateDot();

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft <= 5) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (
        this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])
      ) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    isSlideVisible(element, offset) {
      offset = offset || 0;
      var lastVisibleSlide =
        this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (
        element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
        element.offsetLeft >= this.slider.scrollLeft - 5
      );
    }

    onButtonClick(event) {
      event.preventDefault();
      if (this.sliderItemsToShow.length < 2) return;
      var step = parseInt(event.currentTarget.dataset.step, 10) || 1;
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
      this.setSlidePosition(this.slideScrollPosition);
    }

    setSlidePosition(position) {
      this.position = Math.max(0, position);
      this._scrollToDebounced();
    }

    scrollTo() {
      if (this.slider && this.position !== undefined) {
        this.slider.scrollTo({
          left: this.position,
          behavior: 'smooth'
        });
      }
    }

    onDotClick(event) {
      event.preventDefault();
      var dotIndex = this.dots.indexOf(event.currentTarget);
      if (dotIndex === -1 || !this.sliderFirstItemNode) return;
      var slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * (dotIndex + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition,
        behavior: 'smooth'
      });
    }

    updateDot() {
      this.dots.forEach(
        function (dot, i) {
          if (i + 1 === this.currentPage) {
            dot.classList.add('is-active');
          } else {
            dot.classList.remove('is-active');
          }
        }.bind(this)
      );
    }
  }

  if (!customElements.get('slider-component')) {
    customElements.define('slider-component', SliderComponent);
  }
})();
